import StandardContactFields from '../lib/StandardContactFields/StandardContactFields';
import StandardContactAddressSubFields from '../lib/StandardContactFields/StandardContactAddressSubFields';
import { getIn } from 'icepick';

import { REGISTRATION_TYPE_ID_FIELD_ID, CONTACT_TYPE_ID_FIELD_ID } from '../constants/Fields';

const customContactFieldsToCheck = [
  'MultiChoice',
  'SingleChoice'
];

const getFieldIds = () => {
  const fieldIdArray = Object.keys(StandardContactFields).map(key => {
    return StandardContactFields[key].id;
  });

  fieldIdArray.push(REGISTRATION_TYPE_ID_FIELD_ID, CONTACT_TYPE_ID_FIELD_ID);

  return fieldIdArray;
};

const checkForRegTypes = (visibilityLogic) => {
  let regTypesPresent = false;
  visibilityLogic.filters.forEach(visibilityFilter => {
    if (visibilityFilter.fieldName) {
      if (visibilityFilter.fieldName === REGISTRATION_TYPE_ID_FIELD_ID) {
        regTypesPresent = true;
      }
    } else if (visibilityFilter.filters) {
      visibilityFilter.filters.forEach(innerFilter => {
        if (innerFilter.fieldName === REGISTRATION_TYPE_ID_FIELD_ID) {
          regTypesPresent = true;
        }
      });
    }
  });
  return regTypesPresent;
};

const evaluateRegTypeCriteria = (criteria, regTypes) => {
  let validRegTypes = true;
  criteria.forEach(criterion => {
    if (!regTypes.hasOwnProperty(criterion.value)) {
      validRegTypes = false;
    }
  });
  return validRegTypes;
};

const evaluateCustomContactCriteria = (filter, customContactField) => {
  const customContactChoices = customContactField.question.questionTypeInfo.choices;
  let customContactValues = [];
  let cleanedValues = [];

  customContactChoices.forEach(contactChoice => {
    customContactValues.push(contactChoice.text);
  });

  filter.values.forEach(criteria => {
    if (customContactValues.includes(criteria.value)) {
      cleanedValues.push(criteria);
    }
  });

  return {
    ...filter,
    values: cleanedValues
  };
};

const cleanFilters = (question, regTypes, customContactFields) => {
  const shouldKeepRegTypeCriteria = checkForRegTypes(question.visibilityLogic);
  let cleanedFilters = [];
  const displayExpression = question.visibility.questionVisibilityLogic.displayExpression;
  const fieldIds = getFieldIds();

  displayExpression.filters.forEach(visibilityFilter => {
    if (fieldIds.includes(visibilityFilter.fieldId) ||
      customContactFields.hasOwnProperty(visibilityFilter.fieldId) ||
      StandardContactAddressSubFields.hasOwnProperty(visibilityFilter.fieldId)) {
      if (visibilityFilter.fieldId === REGISTRATION_TYPE_ID_FIELD_ID) {
        if (shouldKeepRegTypeCriteria && evaluateRegTypeCriteria(visibilityFilter.values, regTypes)) {
          cleanedFilters.push(visibilityFilter);
        }
      } else if (customContactFields &&
        customContactFields.hasOwnProperty(visibilityFilter.fieldId) &&
      customContactFieldsToCheck.includes(customContactFields[visibilityFilter.fieldId]
        .question.questionTypeInfo.questionType)) {
        cleanedFilters.push(evaluateCustomContactCriteria(visibilityFilter,
          customContactFields[visibilityFilter.fieldId]));
      } else {
        cleanedFilters.push(visibilityFilter);
      }
    }
  });

  return {
    ...displayExpression,
    filters: cleanedFilters
  };
};

export function transformVisibilityLogicEventData(question, regTypes = {}, customContactFields = {}, existingQuestion) {
  // if present, persist existing visibility results
  const isVisible = getIn(existingQuestion, ['question', 'isVisible']);
  return {
    ...question,
    question: {
      ...question.question,
      visibility: {
        questionVisibilityLogic: {
          displayExpression: cleanFilters(question.question, regTypes, customContactFields)
        }
      },
      isVisible
    }
  };
}
